import React, {useEffect, useState, useContext, useMemo } from 'react'
import './Header.css';
import { Link } from "react-router-dom";
import Navbar from '../Navbar/Navbar';
import Searchproduct from '../SearchProduct/Searchproduct';
import usericon from '../Images/usericon.png';
import { useAuth } from '../firebase/AuthContext';
import { useCart } from '../AddToCart/CartContext';
import addtocarticon from '../Images/addtocarticon.png';
import { DataContext } from '../ProductCarousal1/DataProvider';
import { useSelector } from "react-redux";
import { topCollection, electronicCollection, homeImprovement } from '../ProductCarousal1/data';
import { doubleproductlistData1, doubleproductlistData2 } from '../Only2ProductCarousal/data';
import { AuthProvider } from '../firebase/AuthContext';
import Receipt from '../Receipt/Receipt';
import DataProvider from "../ProductCarousal1/DataProvider";
import { HeaderContext } from "./HeaderProvider";
import logo from '../Images/authlogo.png';
import { useCollection } from '../DashboardProduct/GenericContext';

const Header = () => {
  const { data: dashboardProducts } = useCollection();

  const headerText = useContext(HeaderContext);
  // Memoize the header content to prevent unnecessary re-renders
  const memoizedHeaderText = useMemo(() => headerText, [headerText]);
useEffect(() => {
          window.scrollTo(0, 0);
      }, []);


  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  }

  const closeMenu = () => {
    setIsOpen(false);
  }
  
  const { cartItemCount } = useCart();
      console.log("Cart Item Count:", cartItemCount);
  
      const { user, handleUserNavigation } = useAuth();

const {loading, loadingMore, loadMoreHomeImprovement, loadMoreElectronicCollection, loadMoreTopCollection, loadMoreOurCollection } = useContext(DataContext);
 
  const {homeImprovement}= useSelector(
  (state) => state.homeImprovement
  );
  const {electronicCollection}= useSelector(
    (state) => state.electronicCollection
    );
  const {topCollection}= useSelector(
    (state) => state.topCollection
    );
    const {ourCollection}= useSelector(
      (state) => state.ourCollection
      );
    // const {homeImprovement}= useSelector(
    //   (state) => state.homeImprovement
    //   );


  // Effect to automatically load more products when reaching the bottom of the page (optional)
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMoreHomeImprovement();
          loadMoreElectronicCollection();
          loadMoreTopCollection();
          loadMoreOurCollection();
        }
      },
      { threshold: 1.0 }
    );

    // const bottomHomeImprovement = document.getElementById("homeImprovement-bottom");
    // const bottomElectronicCollection = document.getElementById("electronicCollection-bottom");
    // const bottomTopCollection = document.getElementById("topCollection-bottom");


    // if (bottomHomeImprovement) observer.observe(bottomHomeImprovement);
    // if (bottomElectronicCollection) observer.observe(bottomElectronicCollection);
    // if (bottomTopCollection) observer.observe(bottomTopCollection);

    // return () => {
    //   if (bottomHomeImprovement) observer.unobserve(bottomHomeImprovement);
    //   if (bottomElectronicCollection) observer.unobserve(bottomElectronicCollection);
    //   if (bottomTopCollection) observer.unobserve(bottomTopCollection);
    // };
  }, [loading, loadingMore]);

      {/* ------header container position fixed when search list is visible------- */}
        const [isListVisible, setIsListVisible] = useState(false);
        const handleListVisibilityChange = (visibility) => {
          setIsListVisible(visibility);
        };
        {/* ------header container position fixed when search list is visible------- */}


        const avatarSrc = user
        ? `https://ui-avatars.com/api/?name=${user.email.charAt(0).toUpperCase()}
           &background=000000
           &color=ffffff
           &size=256`
        : usericon;
    

  return (
    <>
        {/* ------useMemo and header position fixed when search list is visible------- */}
        <header 
          style={{ position: isListVisible ? 'fixed' : '', 
                   top: 0, 
                   width: '100%', 
                   zIndex: 9999
                }}
        >
          {memoizedHeaderText || "Welcome to our Official DayRine Store."} {/* Fallback text */}
        </header>
        {/* ------useMemo and header container position fixed when search list is visible------- */}
        
        {/* <div className='header-container'> */}
        <div className={`header-container ${isListVisible ? 'fixed' : ''}`}>
          <Navbar
           isOpen={isOpen}
           toggleMenu={toggleMenu}
           closeMenu={closeMenu}
           isListVisible={isListVisible}
          />
          <div className='logo-container'>
            {/* <Link to="/" className='logo-link'>shopit🛍</Link> */}
            {/* <Link to="/" className='logo-link'>InPkOnlineShop</Link> */}
            <Link to="/" className='logo-link'
            ><img src={logo} alt='error' className='logo-image'/></Link>
            {/* <i class="ri-shopping-bag-line" /> */}
          </div>

          <div className='search-product'>
            <Searchproduct 
              productData={[...topCollection,
              ...electronicCollection,
              ...homeImprovement, 
              ...ourCollection, 
              // ...doubleproductlistData2,
              ...(Array.isArray(dashboardProducts) ? dashboardProducts : dashboardProducts ? [dashboardProducts] : [])

             ]} 
              // ------header container and header position fixed when search list is visible-------
              onListVisibilityChange={handleListVisibilityChange} />
          </div>

          <div className='cart-login-icon'>
            <Link to="/cart" className='cart-link'>
              {cartItemCount > 0 && <span className="cart-count">{cartItemCount}</span>}
              {/* <img src={addtocarticon} 
                   alt="AddtoCartIconError" 
                   className='cart-icon'
              /> */}
              <i class="ri-shopping-bag-line" style={{fontSize:'2rem', color:'#046287', cursor:'pointer'}} />
            </Link>

            {/* <img 
              src={avatarSrc} 
              // src={user ? `https://ui-avatars.com/api/?name=${user.email.charAt(0)}&size=256` : usericon}
              alt="Login" 
              onClick={(e) => {
                e.stopPropagation(); // Prevent triggering the product click event
                handleUserNavigation(); // Add the item to the cart
              }} 
              className='login-icon' 
            /> */}
            <i 
              class="ri-account-circle-line" 
              style={{fontSize:'2.2rem', color:'#046287', cursor:'pointer'}}
              onClick={(e) => {
                e.stopPropagation(); // Prevent triggering the product click event
                handleUserNavigation(); // Add the item to the cart
              }} 
            />
            {/* <i class="ri-account-circle-fill" 
              style={{fontSize:'40px'}}
            /> */}
          </div>
        </div>
    </>
  )
}

export default Header